// component
import SvgColor from "../../../components/svg-color"

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
)

const navConfig = [
  {
    title: "dashboard",
    path: "/admin/dashboard",
    icon: icon("ic_analytics"),
    level: 5,
  },
  {
    title: "User Management",
    path: "/admin/user-management",
    icon: icon("ic_users"),
    level: 5,
  },
  {
    title: "Device Management",
    path: "/admin/device-management",
    icon: icon("ic_device"),
    level: 5,
  },
  {
    title: "Firmware Upgrade",
    path: "/operator/upgrade",
    icon: icon("ic_serial"),
    level: 2,
  },
  {
    title: "Connected Devices",
    path: "/user/connected-devices",
    icon: icon("ic_connected"),
    level: 1,
  },
  // {
  //   title: "Production Statistic",
  //   path: "/admin/statistics",
  //   icon: icon("ic_statistics"),
  //   level: 5,
  // },
  // {
  //   title: "Production Setting",
  //   path: "/user/production-setting",
  //   icon: icon("ic_settings"),
  //   level: 2,
  // },
  // {
  //   title: "Sensor Test",
  //   path: "/operator/sensor-test",
  //   icon: icon("ic_sensor_testing"),
  //   level: 1,
  // },
  // {
  //   title: "Move Sensor Test",
  //   path: "/operator/move-sensor-test",
  //   icon: icon("ic_move"),
  //   level: 1,
  // },
  // {
  //   title: "PCB Registration",
  //   path: "/operator/pcba",
  //   icon: icon("ic_pcb"),
  //   level: 1,
  // },
  // {
  //   title: "LTE Test",
  //   path: "/operator/lte-test",
  //   icon: icon("ic_lte"),
  //   level: 1,
  // },
  // {
  //   title: "TID Registration",
  //   path: "/operator/tid",
  //   icon: icon("ic_barcode"),
  //   level: 1,
  // },
  // {
  //   title: "Finished Product Test",
  //   path: "/operator/finished-test",
  //   icon: icon("ic_battery"),
  //   level: 1,
  // },
  // {
  //   title: "Packing Registration",
  //   path: "/operator/packing",
  //   icon: icon("ic_packing"),
  //   level: 1,
  // },
]

export default navConfig
